import React, { createContext } from 'react';
import { api } from '../../hooks/api.hooks';

interface SchemaContext {
  schema: Api.Domain[];
}

const schemaContext = createContext<SchemaContext>({
  schema: [],
});

export const useSchema = () => React.useContext<SchemaContext>(schemaContext);
export const SchemaProvider: React.FC = ({ children }) => {
  const [schema, setSchema] = React.useState<Api.Domain[]>([]);

  React.useEffect(() => {
    const fetch = async () => {
      const { data } = await api.get<Api.Domain[]>('/schema');
      setSchema(data);
    };

    fetch();
  }, []);

  return (
    <schemaContext.Provider
      value={{
        schema,
      }}
    >
      {children}
    </schemaContext.Provider>
  );
};
